export const messageConstants = {
    MESSAGE_SHOW: "MESSAGE_SHOW",
    MESSAGE_HIDE: "MESSAGE_HIDE"
}